export const normalizeImportRubricResponse = response => Object.values(response).map(question => question.split('\n'))

export const normalizeBuildQuestionDefinitionsResponse = response =>
    Object.values(response).map(question => ({
        id: Math.floor(Math.random() * 1000000),
        matchingQuestionId: question.matching_question_id,
        name: question.name,
        wordsLimit: question.word_count_limit,
        weight: question.weight,
        categories: question.categories.map(category => ({
            id: Math.floor(Math.random() * 1000000),
            name: category.name,
            feedback: category.feedback,
            grade: category.grade,
        })),
        unmatched: question.extra_content,
        summary: question.question_summary,
    }))

/**
 * Normalize a pattern from the API response
 */
export const normalizePattern = pattern => ({
    id: pattern.id,
    name: pattern.name,
    description: pattern.description,
    philosophyText: pattern.philosophy_text,
    feedback: pattern.feedback,
    grade: pattern.grade,
    colorId: pattern.color_id,
    order: pattern.order,
    type: pattern.type,
    deleted: pattern.deleted,
    conceptualLabels: pattern.conceptual_labels,
    attributes: pattern.attributes,
    autoApprove: pattern.auto_approve !== undefined ? pattern.auto_approve : true,
})

/**
 * Normalize a QuestionRubric (the association between question and rubric)
 */
export const normalizeQuestionRubric = questionRubric => ({
    id: questionRubric.id,
    questionId: questionRubric.question_id,
    rubricId: questionRubric.rubric_id,
    name: questionRubric.name,
    position: questionRubric.position,
    processing: {
        status: questionRubric.processing_status,
        message: questionRubric.processing_msg,
        progress: questionRubric.processing_progress,
    },
    llmFeatureQuestions: questionRubric.llm_feature_questions,
    useLlm: questionRubric.use_llm,
    llmWithReasoning: questionRubric.llm_with_reasoning,
    trainingMode: questionRubric.training_mode,
    thresholds: {
        low: questionRubric.low_threshold,
        high: questionRubric.high_threshold,
        veryHigh: questionRubric.very_high_threshold,
    },
    lastTrained: questionRubric.last_trained,
    createdAt: questionRubric.created_at,
})

/**
 * Normalize a Rubric response (basic)
 */
export const normalizeRubric = rubric => ({
    id: rubric.id,
    name: rubric.name,
    content: rubric.content,
    gradingReferenceContent: rubric.grading_reference_content,
    weight: rubric.weight,
    createdAt: rubric.created_at,
})

/**
 * Normalize a Rubric with categories response
 */
export const normalizeRubricWithPatterns = rubric => ({
    ...normalizeRubric(rubric),
    categories: (rubric.patterns || []).map(normalizePattern),
    questionRubrics: (rubric.question_rubrics || []).map(qr => ({
        id: qr.id,
        questionId: qr.question_id,
    })),
})

/**
 * Normalize a list of rubrics with categories
 */
export const normalizeRubricsResponse = response => 
    (response || []).map(normalizeRubricWithPatterns)

/**
 * Normalize a list of categories
 */
export const normalizeCategoriesResponse = response =>
    (response || []).map(normalizePattern)

/**
 * Normalize a list of QuestionRubrics
 */
export const normalizeQuestionRubricsResponse = response =>
    (response || []).map(normalizeQuestionRubric)

/**
 * Normalize processing progress response for question rubrics
 */
export const normalizeRubricProgressResponse = response =>
    (response || []).map(progress => ({
        id: progress.id,
        questionId: progress.question_id,
        rubricId: progress.rubric_id,
        processing: {
            status: progress.processing_status,
            message: progress.processing_msg,
            progress: progress.processing_progress,
        },
    }))
